<template>
    <DsModal
        is-open
        next
        show-close
        dialog
        size="sm"
        :title="$t('funnel.campaign.reporting.filter.modal.title')"
        @close="$emit('close')"
    >
        <DsMultiselect
            v-model="selectedPreset"
            data-qa="preset-dropdown"
            class="preset-dropdown"
            bind-value-only
            :options="presetOptions"
            :placeholder="$t('funnel.campaign.reporting.filter.preset.label')"
        />
        <div v-if="showDatePicker" class="date-range-picker-container">
            <DsDatePicker
                v-model="selectedDateRange"
                data-qa="date-range-picker"
                range
                bind-value-only
                :force-invalid="invalidDateRange"
                :label="$t('funnel.campaign.reporting.filter.dateRange.label')"
            >
                <template #error>
                    <span data-qa="invalid-date-range-alert">
                        {{ $t('funnel.campaign.reporting.filter.dateRange.error') }}
                    </span>
                </template>
            </DsDatePicker>
        </div>


        <div class="timezone-label">
            {{ `${$t('funnel.campaign.reporting.filter.timezone.label')} ${timezone} Time` }}
        </div>

        <hr />

        <div class="button-container">
            <DsFilledButton aria-label="save-button" @click="saveFilters">
                {{ $t('global.save') }}
            </DsFilledButton>

            <DsTextButton aria-label="cancel-button" @click="$emit('close')">
                {{ $t('global.cancel') }}
            </DsTextButton>
        </div>
    </DsModal>
</template>

<script>
import { PRESET_FILTERS } from '../utils/editor.constants';

export default {
    props: {
        dateRange: {
            type: Array,
            default: () => [],
        },
        preset: {
            type: String,
            default: () => PRESET_FILTERS.LAST_24_HOURS,
        },
    },

    emits: ['on-update-filters', 'close'],

    data() {
        return {
            invalidDateRange: false,
            selectedPreset: this.preset,
            selectedDateRangeValue: this.dateRange,
        };
    },

    computed: {
        selectedDateRange: {
            get() {
                return this.selectedDateRangeValue;
            },
            set(value) {
                this.invalidDateRange = false;
                this.selectedDateRangeValue = value;
            },
        },

        timezone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
        showDatePicker() {
            return this.selectedPreset === PRESET_FILTERS.CUSTOM;
        },

        presetOptions() {
            return [
                { label: this.$t('funnel.campaign.reporting.filter.preset.label.CURRENT'), value: PRESET_FILTERS.CURRENT },
                { label: this.$t('funnel.campaign.reporting.filter.preset.label.LAST_24_HOURS'), value: PRESET_FILTERS.LAST_24_HOURS },
                { label: this.$t('funnel.campaign.reporting.filter.preset.label.LAST_7_DAYS'), value: PRESET_FILTERS.LAST_7_DAYS },
                { label: this.$t('funnel.campaign.reporting.filter.preset.label.LAST_30_DAYS'), value: PRESET_FILTERS.LAST_30_DAYS },
                { label: this.$t('funnel.campaign.reporting.filter.preset.label.CUSTOM'), value: PRESET_FILTERS.CUSTOM },
            ];
        },
    },

    methods: {
        saveFilters() {
            this.invalidDateRange = false;

            if (this.selectedPreset === PRESET_FILTERS.CUSTOM) {
                if (this.selectedDateRange.length !== 2) {
                    this.invalidDateRange = true;
                }

                if (this.selectedDateRange[0].toISOString() === this.selectedDateRange[1].toISOString()) {
                    this.invalidDateRange = true;
                }
            }

            if (this.invalidDateRange) return;

            this.$emit('on-update-filters', { preset: this.selectedPreset, dateRange: this.selectedDateRange });
        },
    },
};
</script>

<style scoped lang="scss">
div:deep(.dropdown-menu) {
    max-height: 18rem;
}
div:deep(.modal-body) {
    padding: 0;
}

.timezone-label {
    color: $color-ink-800;
    font-size: $font-size-xs;
    line-height: $line-height-sm;
    margin: $spacing-200 0;
}
.button-container {
    display: flex;
    grid-gap: $spacing-200;
    margin-top: $spacing-300;
}

// css bleed
hr {
    margin: 1em 0;
}
</style>
